import type { SelectType } from "@/types/forms";

export const sortingData: SelectType[] = [
  {
    label: "default",
    value: "default",
  },
  {
    label: "newest",
    value: "new",
  },
  {
    label: "lower_price",
    value: "promo_price",
  },
  {
    label: "rating",
    value: "rating",
  },
  {
    label: "rating_count",
    value: "rating_count",
  },
];
